import CityPageTemplate from "../city-template/CityPageTemplate";
import { losAngelesConfig } from "./data";

export default function LosAngelesPage() {
  return <CityPageTemplate config={losAngelesConfig} />;
}